import * as React from 'react'
import { styled, FontWeight, theme } from '$utils/theme'
import dropdownIcon from '$icons/bars.svg'
import closedIcon from '$icons/cross.svg'
import { Icon } from '../Icon'
import { Division } from '../Division'
import { Button } from '../Button'
import { rem } from 'polished'
import { Text } from '$views/components/Text'
import { ClickOutside } from '../ClickOutside'
import MediaQuery from 'react-responsive'
import { Circle } from '$views/components/Circle'
import { Block } from '$views/components/Layout/Block'

interface Props {
  className?: string
  visible?: boolean
  href?: string
  color?: string
  lastItem?: boolean
  onClick?: any
  onBlur?: any
  home?: boolean
  circle?: boolean
}

interface State {
  isOpen: boolean
}

const DropdownContent = styled.div.attrs({})<Props>`
  box-shadow: 0 2px 6px rgba(117, 117, 117, 0.16);
  border-radius: 2px;
  background-color: ${p => p.theme.colors.white};
  display: ${p => (p.visible ? 'block' : 'none')};
  position: absolute;
  right: 1rem;
  top: 3.5rem;
  padding: ${p => rem(p.theme.sizes.small)} ${p => rem(p.theme.sizes.mini)};
  width: ${rem(224)};
  ${p => p.theme.media.onlyMobile`
    max-width: none;
    padding-top: 0;
    height: 100vh;
    width: 100%;
    right: 0;
    top: 3.1rem;
  `} ${p =>
    p.home &&
    p.theme.media.onlyMobile`
      height: 100vh;
      width: 100%;
      right: 0;
      top: 3.8rem !important;
    `}
  text-align: left;
`

const StyledButton = styled(Button).attrs({})<Props>`
  background-color: transparent;
  border: none;
  padding: 0;
  ${p => p.theme.media.desktop`margin-top: ${rem(p.theme.sizes.base)};`};
  &:hover {
    cursor: pointer;
    background-color: transparent;
    border-color: transparent;
  }
  > span {
    width: ${p => rem(p.theme.sizes.small)};
    height: ${p => rem(p.theme.sizes.small)};
  }
  ${p =>
    p.home &&
    p.theme.media.onlyMobile`
      position: relative;
      top: 3px;
    `};
`

const DropdownIcon: React.SFC<Props> = ({ onClick, onBlur, color, home, ...props }) => (
  <StyledButton onClick={onClick} onBlur={onBlur} home={home}>
    <MediaQuery minWidth={theme.breakpoints.desktop}>
      <Icon content={dropdownIcon} size="l" color={color} />
    </MediaQuery>
    <MediaQuery maxWidth={theme.breakpoints.desktop - 1}>
      <Icon content={props.visible ? closedIcon : dropdownIcon} size="l" color={color} />
    </MediaQuery>
  </StyledButton>
)

export const StyledItemText = styled(Text)`
  ${p => p.theme.font.base(FontWeight.regular)};
  font-size: 20px;
  ${p => p.theme.media.desktop`margin-top: ${rem(p.theme.sizes.base)};
    margin-bottom: ${rem(p.theme.sizes.base)};`};
  margin-top: ${p => rem(p.theme.sizes.small)};
  margin-bottom: ${p => rem(p.theme.sizes.small)};
`

const StyleButton = styled.button`
  cursor: pointer;
  border: none;
  width: 100%;
  background-color: transparent;
  text-align: left;
  &:focus {
    outline: none;
  }
  > p {
    &:hover,
    &:active {
      font-weight: 500;
    }
  }
`

export const DropdownItem: React.SFC<Props> = ({ children, ...props }) => (
  <Block>
    <StyleButton onClick={props.onClick}>
      <StyledItemText color="darkGrey">{children}</StyledItemText>
    </StyleButton>
    {props.circle && <Circle top="30%" left="45px" right="auto" />}
    {!!!props.lastItem && <Division color="lightGrey" />}
  </Block>
)

export class DropdownMenu extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = { isOpen: false }
  }

  toggleMenu = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  render() {
    const { children, color, home } = this.props
    return (
      <ClickOutside onClickOutside={this.hideContent}>
        <div>
          <DropdownIcon onClick={this.toggleMenu} color={color} home={home} visible={this.state.isOpen} />
          <DropdownContent visible={this.state.isOpen} home={home}>
            {children}
          </DropdownContent>
        </div>
      </ClickOutside>
    )
  }

  private hideContent = () => {
    this.setState({ isOpen: false })
  }
}



// WEBPACK FOOTER //
// ./src/views/components/DropdownMenu/DropdownMenu.tsx